module.exports = __webpack_public_path__ + "static/media/me-closeup-nobg.5d1b4f89.png";